import styled, {css} from "styled-components"

import BrandAvatar from "@irati/ui/src/BrandAvatar"

const DealAvatar = styled(BrandAvatar)`
  width: 80px;
  height: 80px;
  max-width: none;
  object-fit: contain;

  ${({theme}) => css`
    ${theme.mediaQueries.minWidthMedia.tablet`
      width: 140px;
      height: 140px;
    `}
  `}
`

export const MobileDealAvatar = styled(DealAvatar)`
  margin-top: -80px;
  margin-left: 20px;

  ${({theme}) => css`
    ${theme.mediaQueries.minWidthMedia.tablet`
      margin-top: -120px;
      margin-left: 20px;
    `}
  `}
`

export default DealAvatar
